<template>
  <div>
    <div class="thisTitle">
      <span class="thisIcon">
        <img src="../../common/images/icon-tixilogo.png" alt=""/>
      </span>
      <span>体系</span>
    </div>
    <div class="TiXiWrap">
      <el-table :data="tableData" class="filterTable" size="small" border style="width: 100%"
                header-row-class-name="table-header" v-loading="loading">
        <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
        <el-table-column prop="masterName" label="项目名称" align="center"></el-table-column>
        <el-table-column :label='item.name' width="220" align="center" v-for="(item,index) in cols" :key="index">
          <template slot-scope="scope">
            <div v-for="(item2,index2) in message" :key="index2"
                 v-if="item2.masterId == scope.row.masterId && item2.scoreType == item.scoreType"
                 class="isChecked" :class="{pointer : isEdit}"
                 @click="changeState(scope.row.masterId,item2.scoreType,scope.row.masterName)">
              <img src="../../common/images/icon-checked.png" alt="">
              已选择
            </div>
            <div>
              <div v-if="isEdit" :class="{pointer : isEdit}"
                   @click="changeState(scope.row.masterId,item.name,scope.row.masterName)">
                <img src="../../common/images/icon-circle.png" alt="">
                请选择
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  //韩金辰7月重写
  import {mapMutations} from "vuex";

  export default {
    name: "TiXi",
    data() {
      return {
        cols: [
          {name: '积分', scoreType: 1},
          {name: '星级', scoreType: 2},
          {name: '信用', scoreType: 3},
        ],
        tableData: [],
        loading: false,
        message: []
      };
    },
    props: ["isEdit"],
    mounted() {
      this.getData();
    },
    methods: {
      ...mapMutations(["changeSystemArr"]),
      getData() {
        this.loading = true
        //这个接口跟其他页面无关，数据也能从别的地方过滤出来，作用也就是方便而已，先留着
        this.$http({
          method: "get",
          url: "/rest/ScoreSystemSettings/searchMastName"
        }).then(res => {
          this.tableData = res.data;
          this.loading = false
          this.message = this.$store.state.systemArr;
        }).catch(() => {
          this.loading = false
        })
      },
      changeState(masterId, scoreType, masterName) {
        if (this.isEdit) {
          this.cols.map(item => {
            let type = item.scoreType
            if (scoreType == item.name) {
              this.message.push({
                "scoreType": type,
                "masterId": masterId,
                "signId": -1,
                "masterName": masterName
              })
            } else if (scoreType == type) {     //如果Type 等于1  那么积分就已经被选中 2星级3信用
              this.message.map((item2, index2) => {
                if (item2.masterId == masterId && item2.scoreType == type) {
                  this.message.splice(index2, 1)
                }
              })
            }
          })
          this.changeSystemArr(this.message)
        }
      }
    }
  };
</script>
<style scoped>
  .TiXiWrap {
    background-color: white;
    padding: 20px;
    margin-bottom: 15px;
  }

  .thisIcon {
    width: 20px;
    height: 20px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 50%;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .thisTitle span:last-child {
    font-size: 15px;
    vertical-align: middle;
    font-weight: bold;
  }

  .isChecked {
    background-color: #e2e7fb;
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
  }

  .el-table td div {
    box-sizing: border-box;
    height: 40px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Assessment/TiXi.vue